import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PestRef } from '../../services/pestService';
import MultiSelectCombo from './MultiSelectCombo';

interface Props {
  options: PestRef[];
  value: string[];            // selected pest codes
  onChange: (codes: string[]) => void;
}

const PestMultiSelect: React.FC<Props> = ({ options, value, onChange }) => {
  const { t } = useTranslation();
  const items = options.map(p => ({ code: p.code, label: p.name }));
  return (
    <MultiSelectCombo
      items={items}
      value={value}
      onChange={onChange}
      ariaLabel={t('common.multiselect.selectPests', { defaultValue: 'Select pests' })}
    />
  );
};

export default PestMultiSelect;
